import { Rad } from '../../lib/types/models/rad/rad'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export interface AssignJourneysToRadRequest {
  journeyIds: number[]
}

export function assignJourneysToRad(input: UpdateInput<AssignJourneysToRadRequest>) {
  const { id, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.rads.assignJourneys.url, { id }))
    .patch<Rad, Partial<AssignJourneysToRadRequest>>(rest)
}
